import { rHandler } from '@/plugins/RHandler';
import { DEFAULT_PARAMS } from '@/utils/objectsRHandler';
import { apiService } from '@/services/APIService';

import { rServices } from '@/plugins/api';

import BaseModel from './base';

export default class EventAssociation extends BaseModel {
  constructor(association, url) {
    super(association, url);
    this.image = association.image || null;
    this.description = association.description;

    this.users = association.users || []; // Менеджеры или управляющие (ОРГАНИЗАТОРЫ)
    this.owner = association.owner || null;

    this.my = association.my || false; // expand=my ; По сути, просто смотрит, данный орг находится ли внутри association.users
  }

  async getManagersData() {
    const params = {
      'search[user_id]': this.users.map(({ id }) => id),
    };
    return rServices.user.getOrganizators({ params });
  }

  usersAttach({ data } = DEFAULT_PARAMS) { // { user_id }
    return rHandler(
      apiService.post(`${this.url}/${this.id}/users/attach`, data),
      (response) => ({ response }),
      (error) => ({ error }),
    );
  }

  usersDetach({ data } = DEFAULT_PARAMS) {
    return rHandler(
      apiService.post(`${this.url}/${this.id}/users/detach`, data),
      (response) => ({ response }),
      (error) => ({ error }),
    );
  }
}
